<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='考核表设置' label2="增加考核表" url="/basicinfo/evaluation/list"></PageHead>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body">
          <!--begin: Form Body -->
          <div class="form-group m-form__group row">
            <label class="col-lg-2 col-form-label">考核表名称：</label>
            <div class="col-lg-3">
              <el-form-item prop="etname" :rules="{required: true, message: '考核表名称不能为空', trigger: 'blur'}">
                <el-input v-model="form.etname"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-lg-2 col-form-label">考核表类型：</label>
            <div class="col-lg-3">
              <el-form-item prop="ettype" :rules="{required: true, message: '考核表类型不能为空', trigger: 'blur'}">
                <el-select v-model="form.ettype" filterable placeholder="请选择">
                  <el-option label="请选择" value=""></el-option>
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-lg-3 col-form-label" style="text-align: right;">评分表内容：</label>
            <div class="col-xl-9 col-lg-7">
              <div class="m_datatable m-datatable--destroyed m-datatable m-datatable--default m-datatable--brand m-datatable--loaded m-datatable--scroll"
                id="local_data" style="position: static; zoom: 1;">
                <template>
                  <div>
                    <el-table :data="form.tableData">
                      <el-table-column prop="etdindex" label="序号" width="100">
                        <template slot-scope="scope">
                          {{scope.row.etdindex}}
                        </template>
                      </el-table-column>
                      <el-table-column prop="etdcontent" label="内容">
                        <template slot-scope="scope">
                          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="scope.row.etdcontent"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column prop="etddesc" label="细则">
                        <template slot-scope="scope">
                          <el-input type="textarea" :rows="2" placeholder="请输入细则" v-model="scope.row.etddesc"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column prop="etdscore" label="分值" width="100">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.etdscore"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column fixed="right" label="操作" width="70">
                        <template slot-scope="scope">
                          <el-button @click.native.prevent="DeleteRow(scope.$index, form.tableData)" type="text" size="small">移除</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </template>
              </div>
            </div>
            <div class="col-xl-1 col-lg-2">
            </div>
          </div>
          <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
            <div class="m-form__actions m-form__actions--solid">
              <div class="row">
                <div class="col-lg-12 m--align-center">
                  <el-button type="primary" icon="el-icon-circle-plus-outline" @click="AddInfo">增加评分项</el-button>
                  <SaveButton :url='saveUrl' back="/basicInfo/evaluation/list"></SaveButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'EvaluationAdd',
    data() {
      return {
        form: {
          token: sessionStorage.getItem('token'),
          etname: '',
          ettype: '',
          options: [{
            value: '1',
            label: '学员考核表'
          }, {
            value: '2',
            label: '带教老师考核表'
          }, {
            value: '3',
            label: '科秘书考核表'
          }],
          tableData: [{
            etdindex: '1',
            etdcontent: '',
            etddesc: '',
            etdscore: ''
          }]
        },
        index: 1,
        saveUrl: this.$utils.Url.zpgl + '/api/APIExamTable/Add'
      }
    },
    methods: {
      AddInfo() {
        let newLine = {
          etdindex: '',
          etdcontent: '',
          etddesc: '',
          etdscore: ''
        }
        this.index += 1
        newLine.etdindex = this.index
        this.form.tableData.push(newLine)
      },
      DeleteRow(index, rows) {
        this.index = this.index - 1
        rows.splice(index, 1)
      },
      Save() {
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIExamTable/Add', this.form, null, null, null, null)
      }
    }
  }
</script>

<style scoped="scoped">
  .el-form-item {
    margin-bottom: 0px;
  }
</style>
